import React, { useState } from 'react';
import { X, Copy, Check } from 'lucide-react';

// ── ПАЛИТРА ЭКРАНА «СЕГОДНЯ» → §3.1 (Ф1, quick-260909-jl8) ─────────────────
// Откат в каждой строке — ПРЕЖНИЙ литерал ЭТОГО ЖЕ места. На fitenko токен
// объявлен (styles/fitenko-tokens.css, селектор html.fitenko) и берётся он;
// на MLG и ELN токена НЕТ — берётся откат, то есть РОВНО прежний цвет.
// 🔴 Значения отката менять нельзя: ими доказывается неизменность чужих арендаторов.
// 🔴 Голый var(--ink) запрещён: у MLG он разрешается в ПУСТОТУ (отсутствие цвета),
//    а не в другой цвет — объявление становится недействительным.
// Класс C (подложки чипов) — по решению владельца от 2026-09-09, вариант B:
// подложка выводится правилом color-mix(in srgb, АКЦЕНТ 14%, --surface); правило
// объявлено ОДИН раз в pages/Dashboard.css под селектором html.fitenko. Бирюза —
// вариант T1: своего тона в §3.1 нет, берётся --green-accent.
const P = {
    ink:         'var(--ink, #1e293b)',  // класс A
    inkDeep:     'var(--ink, #0f172a)',  // класс A
    inkSoft:     'var(--ink, #334155)',  // класс A
    line:        'var(--line, #e2e8f0)',  // класс A
    lineStrong:  'var(--line, #cbd5e1)',  // класс A
    muted:       'var(--ink-muted, #64748b)',  // класс A
    mutedDeep:   'var(--ink-muted, #475569)',  // класс A
    surfaceSoft: 'var(--surface-soft, #f1f5f9)',  // класс A
    teal1:       'var(--green-accent, #10b981)',  // класс B
};




const WidgetEmbedModal = ({ isOpen, onClose, widgetType = 'chat' }) => {
    const [copied, setCopied] = useState(false);

    if (!isOpen) return null;

    const chatCode = `<script src="https://mlg.nygot.com/embed.js"></script>`;

    // [NEW] Calendar Embed Code
    const calendarCode = `<!-- MLG Calendar Widget -->
<div class="mlg-inline-widget" data-url="https://mlg.nygot.com/embed/calendar" data-primary-color="c5a059"></div>
<script src="https://mlg.nygot.com/widget-loader.js" async></script>`;

    const embedCode = widgetType === 'chat' ? chatCode : calendarCode;
    const title = widgetType === 'chat' ? 'Embed Chat Widget' : 'Embed Calendar Widget';
    const desc = widgetType === 'chat'
        ? 'Add the official MLG Chat widget to any website. Copy and paste this code just before the closing </body> tag.'
        : 'Add the official MLG Calendar widget inline on any page. Copy and paste this code where you want the calendar to appear.';

    const handleCopy = () => {
        navigator.clipboard.writeText(embedCode);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
        }}>
            <div style={{
                backgroundColor: 'white',
                borderRadius: '16px',
                width: '600px', // Slightly wider for calendar code
                maxWidth: '90%',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                overflow: 'hidden',
                fontFamily: '-apple-system, system-ui, sans-serif'
            }}>
                {/* Header */}
                <div style={{
                    padding: '20px',
                    borderBottom: `1px solid ${P.line}`,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '600', color: P.ink }}>
                        {title}
                    </h3>
                    <button
                        onClick={onClose}
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: P.muted,
                            padding: '4px'
                        }}
                    >
                        <X size={24} />
                    </button>
                </div>

                {/* Body */}
                <div style={{ padding: '24px' }}>
                    <p style={{ marginTop: 0, marginBottom: '16px', color: P.mutedDeep, lineHeight: '1.5' }}>
                        {desc}
                    </p>

                    <div style={{
                        position: 'relative',
                        backgroundColor: P.surfaceSoft,
                        borderRadius: '8px',
                        padding: '16px',
                        border: `1px solid ${P.line}`
                    }}>
                        <code style={{
                            fontFamily: 'monospace',
                            color: P.inkDeep,
                            wordBreak: 'break-all',
                            fontSize: '0.85rem',
                            display: 'block',
                            whiteSpace: 'pre-wrap' // Preserve formatting
                        }}>
                            {embedCode}
                        </code>

                        <button
                            onClick={handleCopy}
                            style={{
                                position: 'absolute',
                                top: '12px',
                                right: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '8px 12px',
                                backgroundColor: copied ? P.teal1 : 'white',
                                color: copied ? 'white' : P.inkSoft,
                                border: copied ? 'none' : `1px solid ${P.lineStrong}`,
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '0.875rem',
                                fontWeight: '500',
                                transition: 'all 0.2s',
                                boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                            }}
                        >
                            {copied ? <Check size={16} /> : <Copy size={16} />}
                            {copied ? 'Copied' : 'Copy'}
                        </button>
                    </div>

                    <div style={{ marginTop: '20px', fontSize: '0.875rem', color: P.muted }}>
                        <strong>Note:</strong> {widgetType === 'chat' ? 'The widget will appear in the bottom-right corner.' : 'The calendar will fill the width of the container.'}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WidgetEmbedModal;
